window.addEventListener('load', () => {
    setTimeout(() => {
        CNS.$fns.equalizeHeights()
    }, 30)
})